/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuditLogItem } from '../models/audit-log-item';
import { AuditLogPaginatedItems } from '../models/audit-log-paginated-items';
import { listAuditLog } from '../fn/audit-log/list-audit-log';
import { ListAuditLog$Params } from '../fn/audit-log/list-audit-log';
import { listAuditLogForProfileEsg } from '../fn/audit-log/list-audit-log-for-profile-esg';
import { ListAuditLogForProfileEsg$Params } from '../fn/audit-log/list-audit-log-for-profile-esg';

@Injectable({ providedIn: 'root' })
export class AuditLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listAuditLog()` */
  static readonly ListAuditLogPath = '/audit-log/{findBy}';

  /**
   * TODO.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAuditLog()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAuditLog$Response(params: ListAuditLog$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AuditLogItem>>> {
    return listAuditLog(this.http, this.rootUrl, params, context);
  }

  /**
   * TODO.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAuditLog$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAuditLog(params: ListAuditLog$Params, context?: HttpContext): Observable<Array<AuditLogItem>> {
    return this.listAuditLog$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AuditLogItem>>): Array<AuditLogItem> => r.body)
    );
  }

  /** Path part for operation `listAuditLogForProfileEsg()` */
  static readonly ListAuditLogForProfileEsgPath = '/audit-log/esg/profile/{profileId}/esg/{year}/{code}';

  /**
   * For Profile ESF list all audit log events.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAuditLogForProfileEsg()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listAuditLogForProfileEsg$Response(params: ListAuditLogForProfileEsg$Params, context?: HttpContext): Observable<StrictHttpResponse<AuditLogPaginatedItems>> {
    return listAuditLogForProfileEsg(this.http, this.rootUrl, params, context);
  }

  /**
   * For Profile ESF list all audit log events.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAuditLogForProfileEsg$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listAuditLogForProfileEsg(params: ListAuditLogForProfileEsg$Params, context?: HttpContext): Observable<AuditLogPaginatedItems> {
    return this.listAuditLogForProfileEsg$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuditLogPaginatedItems>): AuditLogPaginatedItems => r.body)
    );
  }

}
